import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [seo, setSeo] = useState([])

  useEffect(() => {
    getAllseo();
  }, []);

  const getAllseo = async () => {
    const data = new FormData();
    data.append('name', "nme");

    axios({
      method: 'post',
      url: '/api/hotel/view.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setSeo(s.data)
        console.log(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  {/* Modern Header Added Here */}
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="list" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">View Hotels</h4>
                          <span className="opacity-75">Manage all hotel listings for Makkah and Madinah</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="database" style={{ width: '14px', height: '14px' }}></i>
                          {seo.length} Hotels
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Everything below remains exactly the same */}
                      <div className="table-responsive">
                        <table id="dataTableExample" className="table">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Name</th>
                              {/* <th>des</th> */}
                              <th>Extra</th>
                              <th>img</th>
                              <th>Star</th>
                              <th>Review</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              seo.map((v) => (
                                <tr key={v.id}>
                                  <td>{v.id}</td>
                                  <td>{v.name}</td>
                                  {/* <td>{v.des}</td> */}
                                  <td>{v.ex}</td>
                                  <td>{v.img}</td>
                                  <td>{v.star}</td>
                                  <td>{v.review}</td>
                                 <td>
  <div className="d-flex gap-2">
    <a href={"updatehotel?id=" + v.id}>
      <button className="btn btn-primary btn-sm d-flex align-items-center px-2 py-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
        </svg>
        Edit
      </button>
    </a>
    <a href={"addhotelimg?id=" + v.id + "&hotel_name=" + v.name}>
      <button className="btn btn-primary btn-sm d-flex align-items-center px-2 py-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
        Images
      </button>
    </a>
  </div>
</td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}